"use client";

/**
 * L'option qui dit si le rail B2B est ouvert a TOUS les comptes pro, ou reserve
 * aux comptes internes (roles 1 et 2).
 *
 * C'EST COSMETIQUE, comme le reste de `payLaterEligibility`. Ca decide quel
 * bouton s'affiche, ca n'autorise rien : le serveur relit la meme option et
 * tranche, un client qui se ment a lui-meme recolte un 403.
 *
 * Pourquoi la lire ici plutot que de la deviner : tant que la restriction etait
 * ecrite en dur des deux cotes, ouvrir le rail cote serveur ne montrait le
 * bouton a personne. La bascule n'aurait servi a rien.
 *
 * La valeur est mise en cache pour la duree de la page et partagee entre les
 * appelants (le menu du compte, la page cartes et le tunnel de paiement en
 * demandent tous une) : une seule requete, pas trois. Un echec reseau n'est PAS
 * mis en cache — il rend `false` pour cette fois, et le prochain montage
 * reessaie.
 */
import { useEffect, useState } from "react";

const OPTION_UUID = "OPT-PAY-LATER-OPEN-TO-ALL-PRO";
const TRUTHY = ["true", "1", "yes", "on"];

let cached: boolean | null = null;
let inFlight: Promise<boolean> | null = null;

function readOption(): Promise<boolean> {
  if (cached !== null) return Promise.resolve(cached);
  if (inFlight) return inFlight;

  const base = process.env.NEXT_PUBLIC_SOCKET || "";
  if (!base) return Promise.resolve(false);

  inFlight = fetch(`${base}/api/options/uuid/${encodeURIComponent(OPTION_UUID)}`, {
    headers: { Accept: "application/json" },
  })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      // Une ligne absente vaut « restreint », comme cote serveur.
      cached = TRUTHY.includes(String(data?.value ?? "").trim().toLowerCase());
      inFlight = null;
      return cached;
    })
    .catch(() => {
      inFlight = null;
      return false;
    });

  return inFlight;
}

export function usePayLaterOpenToAllPro(): boolean {
  const [openToAllPro, setOpenToAllPro] = useState<boolean>(cached ?? false);

  useEffect(() => {
    let alive = true;
    readOption().then((value) => {
      if (alive) setOpenToAllPro(value);
    });
    return () => {
      alive = false;
    };
  }, []);

  return openToAllPro;
}

export default usePayLaterOpenToAllPro;
